var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixzeeProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 780,
    viewBox: "0 0 1600 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 780,
    fill: "url(#paint0_linear_562_479)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 492.642,
    y: 282.642,
    width: 614.716,
    height: 215.16,
    rx: 24.9135,
    stroke: "#CD2235",
    strokeWidth: 5.28409
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M551.295 439.355V340.719H603.291L619.636 350.159V394.123L603.291 403.564H571.022V439.355H551.295ZM571.022 357.628V386.655H599.909V357.628H571.022ZM639.363 439.355V340.719H659.091V439.355H639.363ZM674.53 439.355L706.375 388.909L675.939 340.719H698.203L717.507 371.296L736.953 340.719H759.216L728.639 388.909L760.625 439.355H738.362L717.507 406.523L696.794 439.355H674.53ZM773.326 357.628V340.719H840.258V353.4L795.871 422.164V422.446H840.258V439.355H770.508V426.673L814.894 357.909V357.628H773.326ZM879.674 397.082V422.446H918.987V439.355H859.947V340.719H918.987V357.628H879.674V380.173H910.533V397.082H879.674ZM957.009 397.082V422.446H996.322V439.355H937.281V340.719H996.322V357.628H957.009V380.173H987.868V397.082H957.009Z",
    fill: "#CC2135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.44 320.108V316.995H1021.79V320.108H1015.46V337.491H1011.77V320.108H1005.44ZM1024.94 316.995H1029.49L1035.57 331.847H1035.81L1041.9 316.995H1046.44V337.491H1042.88V323.41H1042.69L1037.02 337.431H1034.36L1028.7 323.38H1028.51V337.491H1024.94V316.995Z",
    fill: "#CC2135"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_562_479",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 780,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixzeeProject);
export default __webpack_public_path__ + "static/media/pixzee-project.f5db1f54e5f5c5a1a0ae39842ebc41dd.svg";
export { ForwardRef as ReactComponent };